/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Button from '@atlaskit/button';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { easeInOut, mediumDurationMs } from '@atlaskit/motion';

const expandButtonStyles = css({
  position: 'absolute',
  insetBlockStart: 0,
  insetInlineEnd: 0,
  insetBlockEnd: 0,
});

const chevronIconStyles = css({
  transform: 'rotate(0deg)',
  transition: `transform ${mediumDurationMs}ms ${easeInOut}`,
});

const chevronIconExpandedStyles = css({
  transform: 'rotate(90deg)',
});

type ExpandButtonProps = {
  isOpen: boolean;
  isSelected: boolean;
  onClick: () => void;
  tabIndex?: number;
  title: string;
};

/**
 * __Expand button__
 *
 * An button used to expand / collapse subnavigations.
 */
const ExpandButton = ({
  isOpen = false,
  isSelected = false,
  onClick,
  tabIndex,
  title,
}: ExpandButtonProps) => {
  return (
    <div css={expandButtonStyles}>
      <Button
        iconAfter={
          <span css={[chevronIconStyles, isOpen && chevronIconExpandedStyles]}>
            <ChevronRightIcon size="medium" label="" />
          </span>
        }
        appearance="subtle"
        isSelected={isSelected}
        onClick={onClick}
        aria-expanded={isOpen}
        aria-label={`${title} menu`}
        tabIndex={tabIndex}
      />
    </div>
  );
};

export default ExpandButton;
